import { render, staticRenderFns } from "./ExamProtocol.vue?vue&type=template&id=9acc41ea&"
import script from "./ExamProtocol.vue?vue&type=script&lang=js&"
export * from "./ExamProtocol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports